export default "__VITE_ASSET__CGFrTEfx__"